// extracted by css-extract-rspack-plugin
var _1 = "rR4rFOXa0oIEk1Zu";
var _2 = "kf7MbvSVmqcJa6SQ";
var _3 = "faqD_gD_FbECFBZo";
export { _1 as "chip", _2 as "leagues", _3 as "scroll" }
